<template>
  <div style="background: seagreen">
    <div>
      <h2>Participants</h2>
      <ul>
        <li style="background: chocolate; margin-bottom: 8px" v-for="participant in participants" :key="participant.user_id">
          <span>{{ participant.user_name }}</span>
          <span v-if="participant.local"> (you)</span>

          <div v-if="isOwner && !participant.local">
            <button v-if="participant.audio" @click="audioOff(participant)">Mute</button>
            <button v-if="participant.video" @click="videoOff(participant)">Turn off camera</button>
            <button @click="kickParticipant(participant)">Kick</button>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="isOwner">
      <h2>Waiting participants</h2>
      <ul>
        <li v-for="waitingParticipant in waitingParticipants" :key="waitingParticipant.id">
          <span>{{ waitingParticipant.name }}</span>
          <button
              @click="$store.dispatch('updateWaitingParticipant', {id: waitingParticipant.id, grantRequestedAccess: true})">
            Allow
          </button>
          <button
              @click="$store.dispatch('updateWaitingParticipant', {id: waitingParticipant.id, grantRequestedAccess: false})">
            Deny
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParticipantList",
  computed: {
    participants() {
      return this.$store.state.meeting.participants
    },
    isOwner() {
      return this.$store.state.meeting.isOwner
    },
    waitingParticipants() {
      return this.$store.state.meeting.waitingParticipants
    }
  },
  methods: {
    audioOff(participant) {
      return this.$store.dispatch("participantAudio", {participant, enabled: false})
    },
    videoOff(participant) {
      return this.$store.dispatch("participantVideo", {participant, enabled: false})
    },
    kickParticipant(participant) {
      return this.$store.dispatch("kickParticipant", participant)
    }
  }
}
</script>

<style scoped>

</style>